import { IconButton, Tooltip, alpha, useTheme } from "@mui/material";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "types";
import { useTranslation } from "../../i18n";
import { useContractsStatus } from "../../hooks/useContractsStatus";
import ContractsWizardModal from "./ContractsWizardModal";

export default function ContractsNavChip() {
  const theme = useTheme();
  const { t } = useTranslation();
  const status = useContractsStatus();
  const currentUser = useSelector((s: RootState) => s.auth.user);
  const [modalOpen, setModalOpen] = useState(false);

  const isSystemAdmin = currentUser?.is_system_admin === true;

  if (isSystemAdmin) {
    return null;
  }

  const isOwnerOrAdmin =
    !status.loading &&
    (status.userRole === "owner" || status.userRole === "admin");
  const isKnownNonAdmin =
    !status.loading &&
    status.userRole !== null &&
    status.userRole !== "owner" &&
    status.userRole !== "admin";

  if (isKnownNonAdmin) {
    return null;
  }

  const isComplete = status.overallStatus === "complete";

  if (isComplete) {
    return null;
  }

  const tooltipText = status.agreementStatus !== "not_started"
    ? t("contracts_wizard.chip.pending", "Legal setup pending")
    : t("contracts_wizard.chip.not_started", "Legal setup required");

  return (
    <>
      <Tooltip title={tooltipText}>
        <IconButton
          onClick={() => setModalOpen(true)}
          sx={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: alpha(theme.palette.secondary.main, 0.15),
            color: theme.palette.secondary.main,
            "&:hover": {
              background: alpha(theme.palette.secondary.main, 0.25),
            },
          }}
        >
          <PendingActionsIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
      <ContractsWizardModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
}
